import { NavLink } from "react-router-dom";
import { cn } from "lib/utils";
import { useDueCounts } from "../modal/useDueCounts";

function base() {
  return localStorage.getItem("authUserType") === "admin" ? "/admin/crm" : "/employee/crm";
}

/** The views of the LinkedIn Outreach hub, as a segmented switch (kept visually apart from the stage tabs inside Today).
 *  Today stays at `…/crm/due-today`; the other views sit under it. */
export default function LinkedInHubTabs() {
  const { counts } = useDueCounts(true);
  const waitingOnUs = counts?.conversations_waiting_on_us ?? 0;      // replies we owe an answer to: the Inbox's number
  const views: { label: string; to: string; end: boolean; badge?: number }[] = [
    { label: "Today", to: `${base()}/due-today`, end: true },
    { label: "Pipeline", to: `${base()}/due-today/pipeline`, end: false },
    { label: "Inbox", to: `${base()}/due-today/conversations`, end: false, badge: waitingOnUs },
    { label: "Performance", to: `${base()}/due-today/performance`, end: false },
  ];
  return (
    <nav aria-label="LinkedIn Outreach views" className="inline-flex rounded-lg border border-border bg-surface-muted p-0.5">
      {views.map((v) => (
        <NavLink
          key={v.label}
          to={v.to}
          end={v.end}
          className={({ isActive }) => cn(
            "rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors",
            isActive ? "bg-surface text-primary shadow-sm" : "text-muted-foreground hover:text-foreground",
          )}
        >
          {v.label}
          {!!v.badge && (
            <span className="ml-1.5 rounded-full bg-warning-soft px-1.5 py-px text-xs font-semibold text-warning-soft-foreground tabular-nums"
              title={`${v.badge} ${v.badge === 1 ? "reply" : "replies"} waiting on us`} aria-label={`${v.badge} waiting on us`}>{v.badge}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
